export default __webpack_public_path__ + "static/media/janss.7b6d50a8.jpeg";